import { LabelLarge } from 'baseui/typography';
import { IMultiState } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { OperatorPanelWrapperNoAlarm } from '../../components/Layout'
import { themedUseStyletron } from '../../../theme/customTheme';
import { Badge } from 'baseui/badge';




export function OverviewPanel(props: IMultiState) {
  const [, theme] = themedUseStyletron();
  return (
    <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props}>
      <OperatorPanelWrapperNoAlarm
        objectId={props.id}
        resourceGroupId={props.resourceGroupId}
        statusContent={
          <>
            <Badge hierarchy='secondary' color='accent' content={props.actStateText} />
          </>
        }
        operationModeContent={
          <></>
        }
      >
      </OperatorPanelWrapperNoAlarm>
    </OverviewPanelWrapper>
  );
}